// router.js
import { createRouter, createWebHistory } from 'vue-router';

import AppDash from './pages/AppDash.vue';
import AppLogin from './pages/AppLogin.vue';
import MyWesbite from './pages/MyWesbite.vue';
import PricingList from './pages/PricingList.vue';
import AddWebsite from './pages/AddWebsite.vue';
import HomeAdmin from './pages/HomeAdmin.vue';
import AllCustomers from './pages/AllCustomers.vue';
import Pricing from './pages/Pricing.vue';
import ProfileSettings from './pages/ProfileSettings.vue';
import AiAssistant from './pages/AiAssistant.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: AppDash
  },
  {
    path: '/my_websites',
    name: 'MyWesbite',
    component: MyWesbite
  },
  {
    path: '/pricing_list',
    name: 'PricingList',
    component: PricingList
  },
  {
    path: '/profile_settings',
    name: 'ProfileSettings',
    component: ProfileSettings
  },
  {
    path: '/ai_assistant',
    name: 'AiAssistant',
    component: AiAssistant
  },
  {
    path: '/login',
    name: 'Login',
    component: AppLogin
  },
  {
    path: '/add_website',
    name: 'AddWebsite',
    component: AddWebsite
  },
  {
    path: '/home1',
    name: 'HomeAdmin',
    component: HomeAdmin
  },
  {
    path: '/all_customers',
    name: 'AllCustomers',
    component: AllCustomers
  },
 
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing
  },
  {
    path: '/add_website',
    name: 'AddWebsite',
    component: AddWebsite
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const ldataRaw = sessionStorage.getItem('ldata');
  const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;

  // 1️⃣ No session — redirect to login
  if (!to.path.includes("login") && !ldata) {
    return next("/login");
  }

  // 2️⃣ Logged-in users can't access login
  if (to.path.includes("login") && ldata) {
    if (ldata.type === "admin") return next("/home1");
    return next("/");
  }

  // 3️⃣ Admin visiting /home → go to /home1
  if (to.path === "/home" && ldata && ldata.type === "admin") {
    return next("/home1");
  }

  // 4️⃣ Admin visiting root → go to /home1
  if (to.path === "/" && ldata && ldata.type === "admin") {
    return next("/home1");
  }

  // 5️⃣ User visiting admin page (/home1) → redirect to /home
  if (to.path === "/home1" && ldata && ldata.type === "user") {
    return next("/home");
  }

  // ✅ Otherwise allow navigation
  next();
});



export default router;
